module.exports = __webpack_public_path__ + "static/media/local_mall.25e35776.svg";